import React, { useCallback, useEffect, useState } from 'react'
import {
  MenuItem,
  Select,
  TextField,
  Typography,
  FormControl,
} from '@material-ui/core'
import { useForm } from 'contexts/Form/formContext'
import { MessageType } from 'models/DataFlow'
import { Container } from './styles'
import useTranslator from 'utils/hooks/Translator'

export default function TypeOfMessage({
  metaBlock = false,
}: {
  metaBlock?: boolean
}) {
  const { state, dispatch } = useForm()
  const { dataForm } = state
  const [selectedOption, setSelectedOption] = useState<MessageType>(
    (dataForm?.messageType as MessageType) ?? 'text',
  )

  const { getTranslation } = useTranslator()

  const load = useCallback(() => {
    if (dataForm && !dataForm.messageType) {
      dataForm.messageType = 'text'

      dispatch({
        type: 'updateForm',
        data: {
          dataForm: {
            ...dataForm,
          },
        },
      })
    }
  }, [dataForm, dispatch])

  useEffect(() => {
    load()
  }, [load])

  const handleChangeOption = (newValue: string) => {
    if (dataForm) {
      const value = newValue as MessageType
      setSelectedOption(value)

      dataForm.messageType = value

      dispatch({
        type: 'updateForm',
        data: { dataForm: { ...dataForm } },
      })
    }
  }

  function handleChangeAudioVoice(audioVoice: string) {
    if (!dataForm) return
    dataForm.audioVoice = audioVoice

    dispatch({
      type: 'updateForm',
      data: { dataForm: { ...dataForm } },
    })
  }

  return (
    <Container metaBlock={metaBlock}>
      <Typography
        variant="subtitle2"
        style={{
          marginBottom: 8,
          fontWeight: 500,
        }}
      >
        {getTranslation('typeOfMessage')}
      </Typography>

      <FormControl variant="outlined" fullWidth>
        <Select
          value={selectedOption}
          variant="outlined"
          onChange={(e) => handleChangeOption(String(e.target.value))}
        >
          <MenuItem value={'text'}>
            {getTranslation('typesOfMessage.text')}
          </MenuItem>
          <MenuItem value={'image'}>
            {getTranslation('typesOfMessage.image')}
          </MenuItem>
          <MenuItem value={'tts'}>
            {getTranslation('typesOfMessage.audio')}
          </MenuItem>
          <MenuItem value={'document'}>
            {getTranslation('typesOfMessage.document')}
          </MenuItem>
          <MenuItem value={'video'}>
            {getTranslation('typesOfMessage.video')}
          </MenuItem>
        </Select>
      </FormControl>

      {dataForm?.messageType === 'tts' && (
        <div style={{ marginTop: 16 }}>
          <Typography
            variant="subtitle2"
            style={{
              marginBottom: 8,
              fontWeight: 500,
            }}
          >
            {getTranslation('audioVoice')}
          </Typography>

          <FormControl variant="outlined" fullWidth>
            <TextField
              value={dataForm.audioVoice}
              variant="outlined"
              onChange={(e) => handleChangeAudioVoice(e.target.value)}
              placeholder={getTranslation('audioVoice')}
            />
          </FormControl>
        </div>
      )}
    </Container>
  )
}
